<template>
  <div class="agreementrecord">
    <v-layout row wrap>
      <v-flex xs12 md6>
        <h2>{{agreement.title}}</h2>
      </v-flex>

      <v-flex xs12 md6 class="agreementrecord--share">
        <v-icon small >print</v-icon>
        <a
          :href="agreement.link"
          class="btn-tertiary agreementrecord--share-print"
          target="_blank">
          Printable Version
        </a>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="agreementrecord--document">
        <iframe
          :src="agreement.link"
          :title="agreement.title"
          class="agreementrecord--document-iframe" />
      </v-flex>
    </v-layout>

    <v-layout row wrap class="agreementrecord--signature">
      <v-flex xs12 v-if="hasBeenAgreedTo">
        <p class="agreementrecord--signature-agreed">
          Agreed to by {{agreement.signature}} on {{dotDate(agreement.signed)}}
          at {{formatTime(agreement.signed)}}
        </p>
      </v-flex>

      <v-flex xs12 v-if="showInput">
        <FormRecordInput :agreement="agreement" />
      </v-flex>

      <v-flex xs12 class="agreementrecord--id">
        <p>{{agreement.id}}</p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Mixins } from '@spectorasoftware/homegauge-vue';
import FormRecordInput from './FormRecordInput.vue';

const { DateTime } = Mixins;

export default {
  components: {
    FormRecordInput,
  },
  inject: ['$validator'],
  mixins: [DateTime],
  props: {
    agreement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasBeenAgreedTo() {
      return !!(this.agreement.signed && this.agreement.status !== 'DECLINED');
    },
    showInput() {
      return !!(!this.agreement.signed || this.agreement.status === 'DECLINED');
    },
  },
  methods: {
    formatTime(value) {
      if (!value) return '';
      return new Date(value).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

p {
  color: rgba($theme-color-black, 0.6);
  font-size: 1.286rem;
  margin: 0;
  padding: 0;
}

.agreementrecord {
  ::v-deep .v-input--radio-group__input {
    flex-direction: inherit;
  }

  &--document {
    &-iframe {
      border: solid 1px  rgba($theme-color-black, 0.15);
      height: 315px;
      width: 100%;
    }
  }

  &--id {
    padding: 10px;
    text-align: right;
  }

  &--share {
    text-align: right;

    &-print {
      padding-left: 5px;
    }
  }

  &--signature {
    background-color: $theme-color-offwhite;
    min-height: 100px;
    padding: 10px;

    ::v-deep label {
      font-weight: $typography-weight-bold;
      margin-bottom: 0;
      text-transform: capitalize;
    }

    &-agreed {
      padding: 30px;
    }
  }
}

@media all and (max-width: 944px) {
  h2 {
    text-align: center;
  }

  .agreementrecord {
    &--document {
      padding: 0 20px;
    }

    &--share {
      padding: 10px 0;
      text-align: center;
    }

    &--signature {
      padding: 20px;
    }
  }
}
</style>
